import { ALTERAR_DETALHAMENTO_ENCOMENDA, BUSCAR_ENCOMENDA_ITINERARIO, BUSCAR_ENCOMENDAS, BUSCAR_PEDIDOS } from '../../actions/types'

const initialState = undefined

export default function reducerEncomendas (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_ENCOMENDAS: {
      if (action.payload.encomendas) {
        return {
          ...state,
          encomendas: action.payload.encomendas.encomendas,
          total: action.payload.encomendas.total
        }
      }
      return state
    }

    case BUSCAR_ENCOMENDA_ITINERARIO: {
      if(action.payload.data) {
        const encomendas = action.payload.data.map(encomenda => Object.assign({}, encomenda, { exibirDetalhe: false }));
        return {
          ...state,
          encomendas
        }
      }
      return state;
    }

    case BUSCAR_PEDIDOS: {
      if (action.payload.pedidos) {
        const pedidos = action.payload.pedidos.pedidos.map(pedido => Object.assign({}, pedido, { exibirDetalhe: false }));
        return {
          ...state,
          pedidos,
          total: action.payload.pedidos.total
        }
      }
      return state
    }

    case ALTERAR_DETALHAMENTO_ENCOMENDA: {
      const encomenda = action.payload;
      const indice = state.encomendas.indexOf(encomenda);
      const novaEncomenda = Object.assign({}, encomenda, { exibirDetalhe: !encomenda.exibirDetalhe });
      const encomendas = Object.assign([], state.encomendas);
      encomendas[indice] = novaEncomenda;
      return {
        ...state,
        encomendas
      }
    }

    default: {
      return state
    }
  }
}
